/**
 * @brixon-group/presentation-sdk
 *
 * SDK for building B2B presentations that deploy to the Brixon platform.
 * Primary user: Claude Code (AI coding assistant)
 * Secondary user: Human developers
 */

export const VERSION = '0.0.1'

/**
 * Configuration for a presentation
 */
export interface PresentationConfig {
  /** Unique slug for the presentation URL */
  slug: string
  /** Display title */
  title: string
  /** Optional subtitle */
  subtitle?: string
  /** Client name */
  clientName?: string
  /** Estimated read time in minutes */
  estimatedReadTime?: number
}

/**
 * Section metadata for analytics tracking
 */
export interface SectionConfig {
  /** Unique section identifier */
  id: string
  /** Display label for analytics */
  label: string
  /** Order in presentation */
  order: number
  /** Section type for styling */
  type: 'hero' | 'content' | 'cta' | 'feature' | 'testimonial' | 'pricing'
}

// Re-export components
export {
  Section,
  Hero,
  Content,
  CTA,
  PresentationWrapper,
  cn,
  type SectionProps,
  type HeroProps,
  type ContentProps,
  type CTAProps,
  type PresentationWrapperProps,
} from './components'

// Re-export hooks
export * from './hooks'

// Re-export config types and defineConfig (browser-safe)
// Note: loadConfig is NOT exported here as it uses Node.js modules.
// CLI commands import it directly from './config'
export { defineConfig, type BrixonConfig } from './config-types'
